/*
 * @Author: your name
 * @Date: 2021-07-19 15:38:34
 * @LastEditTime: 2024-04-28 10:22:39
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\cms\index.js
 */
import request from '../request';

const qs = require('qs');

const baseUrl = request.getBaseUrl();
const server = {
  fileUpload: `${baseUrl}/cms/cms/fileUpload`,
  activityFileUpload: `${baseUrl}/cms/cms/activityImageUpload`,
  getCategoryByParentId(params) {
    return request.post('/product/category/selectCategoryByParentId', params);
  },
  // 获取商品详情
  querySkuInfoById(params) {
    return request.fetch(`/product/skuManagement/querySkuInfoForOperator?${qs.stringify(params)}`);
  },

  // 新增模板
  addTemplate: (params) => {
    return request.post(`/cms/templateManagement/addTemplate`, params);
  },
  // 修改模板
  updateTemplate: (params) => {
    return request.post(`/cms/templateManagement/updateTemplate`, params);
  },
  // 获取模板列表
  queryTemplateList(params) {
    return request.post('/cms/templateManagement/queryTemplateList', params);
  },
  // 发布模板
  publishTemplate(params) {
    return request.post('/cms/templateManagement/publishTemplate', params);
  },
  // 查询模板文件
  queryTemplateById(params) {
    return request.post('/cms/templateManagement/queryTemplateById', params);
  },
  //  根据公司id查询首页模板信息
  queryTemplate(params) {
    return request.post('/cms/templateManagement/queryTemplate', params);
  },
  //  发布采购专属区模板
  publishPurchaseTemplate(params) {
    return request.post('/cms/templateManagement/publishPurchaseTemplate', params);
  },
  //  保存采购专属区模板
  savePurchaseTemplate(params) {
    return request.post('/cms/templateManagement/savePurchaseTemplate', params);
  },
  //  查询采购专属区模板
  queryPurchaseTemplate(params) {
    return request.post('/cms/templateManagement/queryPurchaseTemplate', params);
  },
  // 撤回审核申请
  callbackAuditApply(params) {
    return request.post('/cms/templateManagement/callbackAuditApply', params);
  },
  // 查询价格相关
  getNewPriceByProduct(params) {
    return request.post('/price-index/business/price/getNewPriceByProduct', params);
  },
  // 运营人员发布采购专属商城
  publishForAdmin(params) {
    return request.post('/cms/purchaseArea/publishForAdmin', params);
  },

  // 查询公司报名消息列表
  queryCompanySignMessage(params) {
    return request.post('/cms/activity/queryCompanySignMessage', params);
  },
  // 查询活动信息
  queryActivityInfo(params) {
    return request.fetch('/cms/activity/queryActivityInfo', params);
  },

  // 查询活动 商品
  querySupplierProduct(params) {
    return request.post('/cms/activity/querySupplierProduct', params);
  },
  // 查询活动 商品现用
  querySkuListBySkuDTO(params) {
    return request.post('/product/skuManagement/api/querySkuListBySkuDTO', params);
  },
  // 供应商报名--保存
  saveSupplierSignUp(params) {
    return request.post('/cms/activity/saveSupplierSignUp', params);
  },
  // 首页 活动日期
  queryCompanyActivityInviteInfo(params) {
    return request.fetch('/cms/activity/queryCompanyActivityInviteInfo', params);
  },
  // 供应商报名--提交审核
  submitSupplierSignUp(params) {
    return request.post('/cms/activity/submitSupplierSignUp', params);
  },
  // 查询公司报名信息
  queryCompanyEnrollInfo(params) {
    return request.fetch('/cms/activity/queryCompanyEnrollInfo', params);
  },
  // 企业运营后台--查询报名结果--原因查询
  querySignAuditReason(params) {
    return request.post('/cms/activity/querySignAuditReason', params);
  },

  videoFileUpload: `${baseUrl}/cms/cms/companyVideoUpload`, // 视频附件上传

  zoneConfigurationImageUpload: `${baseUrl}/cms/cms/zoneConfigurationImageUpload`, // 图片上传

  certificateUpload: `${baseUrl}/cms/cms/certificateUpload`, // 证书上传

  // 企业主页保存
  saveCompanyConfiguration(params) {
    return request.post('/cms/zoneConfiguration/saveCompanyConfiguration', params);
  },

  // 企业主页信息查询
  getCompanyConfiguration(params) {
    return request.post('/cms/zoneConfiguration/getCompanyConfiguration', params);
  },

  // 查询当前公司简介
  queryCompanyDetailSup(params) {
    return request.post('/user-center/epecCompany/queryCompanyDetail', params);
  },

  // 店铺内容提交审核
  submit(params) {
    return request.post('/cms/shop/submit', params);
  },
  // 供应商查看审核状态
  auditStatus(params) {
    return request.post('/cms/shop/auditStatus', params);
  },

  // 查看正在审核的内容
  auditContent(params) {
    return request.post('/cms/shop/auditContent', params);
  },

  // 供应商撤销审核
  cancel(params) {
    return request.post('/cms/shop/cancel', params);
  },
};
export default server;
